import { HighlightOff, Person } from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import swal from "sweetalert";

const AddVariationForm = ({
  setAddNewBtn,
  setLeftBtn,
  setAddNewVariation,
  refer,
  category,
}) => {
  console.log("categsdsdsdory:", category);

  const [milestoneFields, setMilestoneFields] = useState([{ id: 0 }]);
  const [productInfo, setProductInfo] = useState({});
  console.log("productInfo:", productInfo);
  const [inputField, setInputField] = useState({});
  console.log("inputField:", inputField);
  const [pdfAlertMessage, setPdfAlertMessage] = useState("");
  const [attachment, setAttachment] = useState("");
  const [preview, setPreview] = useState("");
  const [allPhone_code, setAllPhone_code] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  console.log("categoryList:", categoryList);
  console.log("allPhone_code:", allPhone_code);

  useEffect(() => {
    fetch(`https://ghorami.com/profile/login/api_booking/country_list.php`)
      .then((res) => res.json())
      .then((result) => {
        setAllPhone_code(result);
      });
    fetch(
      `http://whatsapp.ghorami.com/api/setting_ap/get_business_category.php`
    )
      .then((res) => res.json())
      .then((result) => {
        setCategoryList(result);
      });
  }, []);

  const handleSend = () => {
    let newObject = localStorage.getItem("wmData");
    let parsedObject = JSON.parse(newObject);
    productInfo.p_user = parsedObject?.SopnoID;
    let others = {
      product_id: refer,
      info: productInfo?.info,
      color: productInfo?.color,
      offerPrice: productInfo?.offerPrice,
      regularPrice: productInfo?.regPrice,
      category: category,
      p_user: parsedObject?.SopnoID,
    };
    const formData = new FormData();
    formData.append("newVariation", JSON.stringify(others));
    formData.append("pro_pic", productInfo.pro_pic);
    formData.append(
      "support_details",
      JSON.stringify(productInfo?.support_details)
    );

    fetch(`https://alqamaralzhabi.com/admin_api/pr_variation_new.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result?.m_type) {
          swal({
            title: result?.m_result,
            text: result?.q_message,
            icon: result?.m_type,
            button: "Done",
          });
          setInputField({});
          setProductInfo({});
          setAddNewVariation(false);
        }
      })
      .catch((error) => console.log("FetchUserApiError=> ", error));
  };
  const handleMilestoneFormChange = (index, event) => {
    if (event.target.name == "ms_date") {
      event.target.name.replace("/", "-");
      let data = [...milestoneFields];
      data[index][event.target.name] = event.target.value;
      data[index].id = index;
      setMilestoneFields(data);
      let newproductInfo = productInfo;
      newproductInfo.support_details = milestoneFields;
      setProductInfo({ ...newproductInfo });
    } else {
      let data = [...milestoneFields];
      data[index][event.target.name] = event.target.value;
      data[index].id = index;
      setMilestoneFields(data);
      let newproductInfo = productInfo;
      newproductInfo.support_details = milestoneFields;
      setProductInfo({ ...newproductInfo });
    }
  };
  const addMilestoneFields = () => {
    let id = Math.floor(Math.random() * 1000000000 + 1);
    let newfield = { id: id };
    setMilestoneFields([...milestoneFields, newfield]);
  };
  const handleDeleteMS = (id) => {
    let filteredField = milestoneFields.filter((element) => element.id != id);
    setMilestoneFields([...filteredField]);
  };
  const handleAttachment = (e) => {
    if (
      e.target.files[0].type == "image/png" ||
      e.target.files[0].type == "image/jpeg"
    ) {
      setAttachment(e.target.files[0]);
      let newInfo = productInfo;
      newInfo[e.target.name] = e.target.files[0];
      setProductInfo({ ...newInfo });
      setPdfAlertMessage("");

      const objectUrl = URL.createObjectURL(e.target.files[0]);
      setPreview(objectUrl);

      // free memory when ever this component is unmounted
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      e.target.value = null;
      setPdfAlertMessage("This is not a valid file!");
    }
  };

  const handleAttachmentCancel = (name) => {
    let newInfo = productInfo;
    newInfo[name] = {};
    setProductInfo({ ...newInfo });
    setPreview("");
  };
  const clear = () => {
    setProductInfo({});
    setInputField({});
  };
  const handleChange = (event) => {
    let isFieldValid = false;

    if (event.target.name === "regPrice") {
      isFieldValid = /[0-9]+/.test(event.target.value);
    }
    if (event.target.name === "offerPrice") {
      isFieldValid = /[0-9]+/.test(event.target.value);
    }
    if (event.target.name === "info") {
      isFieldValid = /[a-z]|[A-Z]/.test(event.target.value);
    }

    if (event.target.name === "color") {
      isFieldValid = /^\S+$/.test(event.target.value);
    }

    if (isFieldValid) {
      const updateField = inputField;
      updateField[event.target.name] = event.target.value;
      updateField.fieldErrorAlert = "";
      setInputField({ ...updateField });

      const newProductInfo = productInfo;
      newProductInfo[event.target.name] = event.target.value;
      setProductInfo({ ...newProductInfo });
    }
    if (!isFieldValid) {
      const newField = { ...inputField };
      newField.fieldErrorAlert = event.target.name;
      newField[event.target.name] = "";
      setInputField(newField);

      const newProductInfo = { ...productInfo };
      newProductInfo.fieldErrorAlert = event.target.name;
      newProductInfo[event.target.name] = "";
      setProductInfo(newProductInfo);
    }
  };
  return (
    <Box>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={1}
        sx={{ marginBottom: "20px" }}
      >
        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Stack direction={"row"} justifyContent="space-between">
              <Typography
                variant="p"
                sx={{
                  fontSize: "10pt",
                  fontWeight: 600,
                }}
              >
                Variation Info
              </Typography>
              {inputField.fieldErrorAlert == "info" && (
                <small style={{ color: "#CB0101" }}>
                  *Number field is empty
                </small>
              )}
            </Stack>

            <OutlinedInput
              type="text"
              name="info"
              size="small"
              placeholder="Enter info"
              sx={{
                width: "100%",
                bgcolor: "#D4EAFF",
                borderRadius: "6px",
                paddingY: "0px",
                fontSize: "9pt",
                boxSizing: "border-box",
              }}
              onChange={handleChange}
            />
          </Stack>
        </Grid>

        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Stack direction={"row"} justifyContent="space-between">
              <Typography
                variant="p"
                sx={{
                  fontSize: "10pt",
                  fontWeight: 600,
                }}
              >
                Color
              </Typography>
              {inputField.fieldErrorAlert === "color" && (
                <small style={{ color: "#CB0101" }}>*Enter color name</small>
              )}
            </Stack>

            <OutlinedInput
              type="color"
              name="color"
              size="small"
              placeholder="Enter color"
              sx={{
                width: "100%",
                bgcolor: "#D4EAFF",
                borderRadius: "6px",
                fontSize: "9pt",
              }}
              onChange={handleChange}
            />
          </Stack>
        </Grid>

        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Stack direction={"row"} justifyContent="space-between">
              <Typography
                variant="p"
                sx={{
                  fontSize: "10pt",
                  fontWeight: 600,
                }}
              >
                Offer price
              </Typography>
              {inputField.fieldErrorAlert === "offerPrice" && (
                <small style={{ color: "#CB0101" }}>*Offer price empty</small>
              )}
            </Stack>

            <OutlinedInput
              type="number"
              name="offerPrice"
              size="small"
              placeholder="Offer price"
              sx={{
                width: "100%",
                bgcolor: "#D4EAFF",
                borderRadius: "6px",

                fontSize: "9pt",
              }}
              onChange={handleChange}
            />
          </Stack>
        </Grid>

        <Grid item xs={6}>
          <Stack spacing={0.5}>
            <Stack
              direction={"row"}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Typography
                variant="p"
                sx={{
                  fontSize: "10pt",
                  fontWeight: 600,
                }}
              >
                Regular price
              </Typography>
              {inputField.fieldErrorAlert === "regPrice" && (
                <small style={{ color: "#CB0101" }}>*Regular price empty</small>
              )}
            </Stack>

            <OutlinedInput
              type="number"
              size="small"
              name="regPrice"
              placeholder="Regular price"
              sx={{
                width: "100%",
                bgcolor: "#D4EAFF",
                borderRadius: "6px",
                fontSize: "9pt",
              }}
              // value={videoUrl}
              onChange={handleChange}
            />
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Stack spacing={0.5}>
            <Stack
              direction={"row"}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Typography
                variant="p"
                sx={{
                  fontSize: "10pt",
                  fontWeight: 600,
                }}
              >
                Upload Documents (jpg/png/pdf file)
              </Typography>
              {pdfAlertMessage && (
                <small style={{ color: "#CB0101" }}>{pdfAlertMessage}</small>
              )}
            </Stack>
          </Stack>

          <Stack
            spacing={0.5}
            direction="row"
            justifyContent={"left"}
            alignItems="center"
            sx={{ width: "100%", height: "auto" }}
          >
            <Button component="label">
              <Stack
                alignItems={"center"}
                justifyContent="center"
                sx={{
                  width: "80px",
                  height: "80px",
                  border: ".5px solid gray",
                  borderRadius: "4px",
                }}
              >
                <Person sx={{ fontSize: "16pt" }} />
                <Typography
                  variant="p"
                  sx={{
                    fontSize: "11pt",
                    fontWeight: 700,
                    textTransform: "capitalize",
                  }}
                >
                  Pic
                </Typography>
              </Stack>
              <input
                type="file"
                hidden
                name="pro_pic"
                size="small"
                sx={{
                  width: "100%",
                  bgcolor: "#D4EAFF",
                  borderRadius: "6px",
                  fontSize: "9pt",
                }}
                onChange={handleAttachment}
              />
            </Button>

            {preview && (
              <Box
                component={"img"}
                src={preview}
                sx={{ width: "85px", borderRadius: "4px" }}
              />
            )}
          </Stack>

          {productInfo?.pro_pic?.name && (
            <Stack spacing={0.5} sx={{ marginTop: "10px" }}>
              <Stack
                direction={"row"}
                alignItems="center"
                justifyContent={"space-between"}
              >
                <Typography
                  variant="p"
                  sx={{ fontSize: "9pt", fontWeight: 700 }}
                >
                  pro_pic - {productInfo?.pro_pic?.name}
                </Typography>

                <HighlightOff
                  sx={{ fontSize: "11pt", cursor: "pointer" }}
                  onClick={() => {
                    handleAttachmentCancel("pro_pic");
                  }}
                />
              </Stack>
            </Stack>
          )}
        </Grid>

        {milestoneFields?.map((input, index) => {
          return (
            <Grid item xs={12} key={index} mb={2}>
              <Stack
                spacing={1}
                direction={"row"}
                justifyContent="space-between"
                alignItems={"center"}
              >
                <Stack spacing={0.5} sx={{ width: "50%" }}>
                  <Stack
                    direction={"row"}
                    justifyContent="space-between"
                    alignItems={"center"}
                  >
                    <Typography
                      variant="p"
                      sx={{
                        fontSize: "11pt",
                        fontWeight: 500,
                      }}
                    >
                      Service Title
                    </Typography>
                  </Stack>
                  <OutlinedInput
                    name="sd_service_title"
                    type="text"
                    size="small"
                    placeholder="Enter your question"
                    sx={{
                      width: "100%",
                      bgcolor: "#D4EAFF",
                      borderRadius: "6px",
                      fontSize: "10pt",
                    }}
                    onChange={(event) =>
                      handleMilestoneFormChange(index, event)
                    }
                  />{" "}
                  <Stack
                    direction={"row"}
                    justifyContent="space-between"
                    alignItems={"center"}
                  >
                    <Typography
                      variant="p"
                      sx={{
                        fontSize: "11pt",
                        fontWeight: 500,
                      }}
                    >
                      Price
                    </Typography>
                  </Stack>
                  <OutlinedInput
                    name="sd_price"
                    type="number"
                    size="small"
                    placeholder="Enter price"
                    sx={{
                      width: "100%",
                      bgcolor: "#D4EAFF",
                      borderRadius: "6px",
                      fontSize: "10pt",
                    }}
                    onChange={(event) =>
                      handleMilestoneFormChange(index, event)
                    }
                  />
                </Stack>
                <Stack spacing={0} sx={{ width: "50%" }}>
                  <Stack
                    direction={"row"}
                    justifyContent="space-between"
                    alignItems={"center"}
                  >
                    <Typography
                      variant="p"
                      sx={{
                        fontSize: "11pt",
                        fontWeight: 500,
                      }}
                    >
                      Service Info
                    </Typography>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={() => {
                        handleDeleteMS(input.id);
                      }}
                    >
                      <HighlightOff fontSize="inherit" />
                    </IconButton>

                    {/* {inputField.fieldErrorAlert === "budget" && (
                                <small style={{ color: "#CB0101" }}>
                                  *Enter milestone details
                                </small>
                              )} */}
                  </Stack>

                  <TextareaAutosize
                    aria-label="minimum height"
                    minRows={5.3}
                    placeholder="Enter support info"
                    name="sd_service_info"
                    type="text"
                    className="customTextField"
                    style={{
                      fontSize: "10pt",
                      fontFamily: `-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, "Oxygen",
                    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue,
                    sans-serif`,
                      width: "100%",
                      maxWidth: "100%",
                      backgroundColor: "#D4EAFF",
                      boxSizing: "border-box",
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      borderRadius: "6px",
                      paddingLeft: "15px",
                      paddingRight: "15px",
                      paddingTop: "10px",
                      // paddingBottom: "5px",
                    }}
                    onChange={(event) =>
                      handleMilestoneFormChange(index, event)
                    }
                  />
                </Stack>
              </Stack>
            </Grid>
          );
        })}
        <Button
          onClick={addMilestoneFields}
          size="small"
          sx={{
            marginLeft: "10px",
            marginTop: "10px",
            textTransform: "capitalize",
          }}
        >
          Add Milestone
        </Button>
        <Grid item xs={12}>
          <Stack
            spacing={1}
            direction="row"
            alignItems={"center"}
            justifyContent="right"
          >
            <Button
              variant="outlined"
              color="info"
              sx={{ textTransform: "capitalize" }}
              onClick={() => {
                clear();
                setAddNewBtn(false);
              }}
            >
              Clear
            </Button>

            {inputField.offerPrice &&
            inputField.regPrice &&
            inputField.info &&
            inputField.color &&
            productInfo.support_details?.[0]?.sd_service_title &&
            productInfo.support_details?.[0]?.sd_price &&
            productInfo?.pro_pic?.name ? (
              <Button
                variant="contained"
                color="success"
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  handleSend();
                  //   setAddNewBtn(false);
                }}
              >
                Save
              </Button>
            ) : (
              <Button
                disabled
                variant="contained"
                color="success"
                sx={{ textTransform: "capitalize" }}
                onClick={() => {}}
              >
                Save
              </Button>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddVariationForm;
